import { render, staticRenderFns } from "./HeadlessBannersEdit.vue?vue&type=template&id=2c4e46ca&"
import script from "./HeadlessBannersEdit.vue?vue&type=script&lang=ts&"
export * from "./HeadlessBannersEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports